import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroGroupLocationDeleteErrorDialogOpen,
  selectMeteorologyAgroGroupLocationDeleteSuccessDialogOpen,
  selectMeteorologyAgroGroupLocationMessage,
  setDeleteErrorDialogOpen,
  setDeleteSuccessDialogOpen,
} from 'redux/reducers/meteorologyAgroGroupLocationFeedbackReducer';
import { store } from 'redux/store';

export default function useGroupLocationDeleteFeedback() {
  const successOpen = useSelector(selectMeteorologyAgroGroupLocationDeleteSuccessDialogOpen);
  const errorOpen = useSelector(selectMeteorologyAgroGroupLocationDeleteErrorDialogOpen);
  const message = useSelector(selectMeteorologyAgroGroupLocationMessage);

  const onCloseSuccess = useCallback(() => {
    store.dispatch(setDeleteSuccessDialogOpen(false));
  }, []);
  const onCloseError = useCallback(() => {
    store.dispatch(setDeleteErrorDialogOpen(false));
  }, []);

  return {
    successOpen,
    errorOpen,
    message,
    onCloseSuccess,
    onCloseError,
  };
}
